import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  "@global": {
    "*::-webkit-scrollbar": {
      width: "6px",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": " inset 0 0 5px rgb(54, 54, 54)",
      borderRadius: "10px",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: "10px",
    },

    "*::-webkit-scrollbar-thumb:hover": {
      backgroundColor: theme.palette.secondary.main,
      width: "10px",
    },
  },
  hiUserName: {
    padding: "3px 0px",
    height: "7%",
    fontSize: "18px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  userName: {
    color: theme.palette.secondary.main,
  },
  cardContentDiv1: {
    justifyContent: "space-around",
    marginTop: "5%",
  },
  cardContentDiv2: {
    // width: "100%",
    // height: "4rem",
    display: "grid",
    placeItems: "center",
    // border: `2px solid ${theme.palette.text.primary}`,
    borderRadius: "5px",
    backgroundColor: "#252A38",
    padding: "4px 10px 4px 10px",
    fontSize: "12px",
  },
  nextPageLoader: {
    width: "43%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  tabs: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "20px",
    width: "100%",
  },
  notSelectedTab: {
    border: `2px solid ${theme.palette.text.tertiary}`,
    borderRadius: "10px",
    borderBottom: "none",
  },
  selectedTab: {
    border: `2px solid ${theme.palette.secondary.main}`,
    borderRadius: "10px",
    borderBottom: "none",
  },
}));

export default useStyles;
